export default "__VITE_ASSET__1dd92ed5__"